import axios from 'axios'
import connom from './common'
import avatar from '@/assets/loading.gif'
import Router from '../../router/index'
axios.defaults.timeout = 600000 // 超时响应
// axios.defaults.baseURL = publish.baseUrl // 根目录地址
let publish = process.env.config
axios.interceptors.request.use(
  config => {
    // const token = getCookie('名称');注意使用的时候需要引入cookie方法，推荐js-cookie
    // config.data = JSON.stringify(config.data)
    if (config.url.indexOf('/api/GetUserByCode') >= 0) {
      config.headers = {
        'Accept-Language': window.localStorage.getItem('language') || 'zh-CN',
        'Ocp-Apim-Subscription-Key': publish.ocpKey
        // 'Origin': publish.originUrl
        // 'sec-fetch-dest': 'empty',
        // 'sec-fetch-mode': 'cors',
        // 'sec-fetch-site': 'same-site'
      }
    } else {
      config.headers = {
        'Authorization': 'Bearer ' + window.localStorage.getItem('gskToken'),
        'Accept-Language': window.localStorage.getItem('language') || 'zh-CN',
        'Ocp-Apim-Subscription-Key': publish.ocpKey
        // 'Origin': publish.originUrl
        // 'sec-fetch-dest': 'empty',
        // 'sec-fetch-mode': 'cors',
        // 'sec-fetch-site': 'same-site'
      }
    }
    // if (config.url.indexOf('?') >= 0) {
    //   config.url = config.url + '&t=' + new Date().getTime()
    // } else {
    //   config.url = config.url + '?t=' + new Date().getTime()
    // }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
function getHrefName (name) {
  var href2 = window.location.href.split('?')[1] || ''
  var href = href2.split('#/')[0] || ''
  var hrefArray = href.split('&')
  for (var i = 0; i < hrefArray.length; i++) {
    if (name === hrefArray[i].split('=')[0]) {
      return hrefArray[i].split('=')[1]
    }
  }
}
export default {
  get (url, type, noLoading) {
    let serviceUrl = publish.baseUrl
    return new Promise((resolve, reject) => {
      if (!noLoading) {
        coverGif()
      }
      axios.get(serviceUrl + url)
        .then(response => {
          disCover()
          if (response.data.isSuccess) {
            resolve(response.data)
          } else {
            if (response.data.message !== 'Current user did not login to the application!') {
              connom.alertTips({
                type: 'error',
                title: '错误:',
                content: response.data.message,
                stayTime: 5
              })
            }
          }
        })
        .catch(err => {
          if (err.response.status === 401 || err.response.status === 403) {
            window.localStorage.removeItem('gskToken')
            window.localStorage.removeItem('gskloginInfo')
            localStorage.emailDownId = getHrefName('id')
            localStorage.emailDownFileName = decodeURIComponent(getHrefName('filename'))
            // window.location.href = publish.ssoUrl
            Router.push('loginHome')
          }
          disCover()
          if (!returnErr(err)) {
            connom.alertTips({
              type: 'error',
              title: '错误:',
              content: '服务器报错',
              stayTime: 5
            })
          }
          reject(err)
        })
    })
  },
  getTwo (url) {
    let serviceUrl = publish.baseUrl
    return new Promise((resolve, reject) => {
      axios.get(serviceUrl + url)
        .then(response => {
          if (response.data.isSuccess) {
            resolve(response.data)
          } else {
            if (response.data.message !== 'Current user did not login to the application!') {
              connom.alertTips({
                type: 'error',
                title: '错误:',
                content: response.data.message,
                stayTime: 5
              })
            }
          }
        })
        .catch(err => {
          disCover()
          if (!returnErr(err)) {
            connom.alertTips({
              type: 'error',
              title: '错误:',
              content: '服务器报错',
              stayTime: 5
            })
          }
          reject(err)
        })
    })
  },
  post (url, data, type, noLoading) {
    let serviceUrl = publish.baseUrl
    return new Promise((resolve, reject) => {
      if (!noLoading) {
        coverGif()
      }
      axios.post(serviceUrl + url, data)
        .then(response => {
          disCover()
          if (response.data.isSuccess) {
            resolve(response.data)
          } else {
            reject(response.data)
            connom.alertTips({
              type: 'error',
              title: '错误:',
              content: response.data.message,
              stayTime: 5
            })
          }
        })
        .catch(err => {
          disCover()
          if (!returnErr(err)) {
            connom.alertTips({
              type: 'error',
              title: '错误:',
              content: '服务器报错',
              stayTime: 5
            })
          }
          // if (err.response.status === 401 || err.response.status === 403) {
          //   window.localStorage.removeItem('gskToken')
          //   window.localStorage.removeItem('gskloginInfo')
          //   window.location.href = publish.ssoUrl
          //   return
          // }
          // connom.alertTips({
          //   type: 'error',
          //   title: '错误:',
          //   content: '服务器报错',
          //   stayTime: 5
          // })
          reject(err)
        })
    })
  },
  postTwo (url, data) {
    let serviceUrl = publish.baseUrl
    return new Promise((resolve, reject) => {
      axios.post(serviceUrl + url, data)
        .then(response => {
          if (response.data.isSuccess) {
            resolve(response.data)
          } else {
            reject(response.data)
            connom.alertTips({
              type: 'error',
              title: '错误:',
              content: response.data.message,
              stayTime: 5
            })
          }
        })
        .catch(err => {
          disCover()
          if (!returnErr(err)) {
            connom.alertTips({
              type: 'error',
              title: '错误:',
              content: '服务器报错',
              stayTime: 5
            })
          }
          // if (err.response.status === 401 || err.response.status === 403) {
          //   window.localStorage.removeItem('gskToken')
          //   window.localStorage.removeItem('gskloginInfo')
          //   window.location.href = publish.ssoUrl
          //   return
          // }
          // connom.alertTips({
          //   type: 'error',
          //   title: '错误:',
          //   content: '服务器报错',
          //   stayTime: 5
          // })
          reject(err)
        })
    })
  },
  postFile (url, data, type) {
    let serviceUrl = publish.baseUrl
    return new Promise((resolve, reject) => {
      coverGif()
      axios.post(serviceUrl + url, data)
        .then(response => {
          disCover()
          if (response.data) {
            resolve(response.data)
          } else {
            connom.alertTips({
              type: 'error',
              title: '错误:',
              content: response.data.message,
              stayTime: 5
            })
          }
        })
        .catch(err => {
          disCover()
          if (!returnErr(err)) {
            connom.alertTips({
              type: 'error',
              title: '错误:',
              content: '服务器报错',
              stayTime: 5
            })
          }
          reject(err)
        })
    })
  },
  put (url, data, type, noLoading) {
    let serviceUrl = publish.baseUrl
    return new Promise((resolve, reject) => {
      if (!noLoading) {
        coverGif()
      }
      axios.put(serviceUrl + url, data)
        .then(response => {
          disCover()
          if (response.data.isSuccess) {
            resolve(response.data)
          } else {
            reject(response.data)
            connom.alertTips({
              type: 'error',
              title: '错误:',
              content: response.data.message,
              stayTime: 5
            })
          }
        })
        .catch(err => {
          disCover()
          if (!returnErr(err)) {
            connom.alertTips({
              type: 'error',
              title: '错误:',
              content: '服务器报错',
              stayTime: 5
            })
          }
          reject(err)
        })
    })
  },
  patch (url, data, type) {
    let serviceUrl = publish.baseUrl
    return new Promise((resolve, reject) => {
      coverGif()
      axios.patch(serviceUrl + url, data)
        .then(response => {
          disCover()
          if (response.data.isSuccess) {
            resolve(response.data)
          } else {
            connom.alertTips({
              type: 'error',
              title: '错误:',
              content: response.data.message,
              stayTime: 5
            })
          }
        })
        .catch(err => {
          disCover()
          if (!returnErr(err)) {
            connom.alertTips({
              type: 'error',
              title: '错误:',
              content: '服务器报错',
              stayTime: 5
            })
          }
          reject(err)
        })
    })
  },
  putCpm (url, data, type) {
    let serviceUrl = publish.baseUrl
    return new Promise((resolve, reject) => {
      coverGif()
      axios.put(serviceUrl + url, data)
        .then(response => {
          disCover()
          resolve(response.data)
        })
        .catch(err => {
          disCover()
          if (!returnErr(err)) {
            connom.alertTips({
              type: 'error',
              title: '错误:',
              content: '服务器报错',
              stayTime: 5
            })
          }
          reject(err)
        })
    })
  },
  del (url, type) {
    let serviceUrl = publish.baseUrl
    return new Promise((resolve, reject) => {
      coverGif()
      axios.delete(serviceUrl + url)
        .then(response => {
          disCover()
          if (response.data.isSuccess) {
            resolve(response.data)
          } else {
            connom.alertTips({
              type: 'error',
              title: '错误:',
              content: response.data.message,
              stayTime: 5
            })
          }
        })
        .catch(err => {
          disCover()
          if (!returnErr(err)) {
            connom.alertTips({
              type: 'error',
              title: '错误:',
              content: '服务器报错',
              stayTime: 5
            })
          }
          reject(err)
        })
    })
  },
  asyncGet (url, type) {
    debugger
    let serviceUrl = publish.baseUrl
    var p = new Promise((resolve, reject) => {
      axios.get(serviceUrl + url).then(msg => {
        resolve(msg.data.data)
      }).catch(err => {
        if (err.response.status === 401 || err.response.status === 403) {
          window.localStorage.removeItem('gskToken')
          window.localStorage.removeItem('gskloginInfo')
          localStorage.emailDownId = getHrefName('id')
          localStorage.emailDownFileName = decodeURIComponent(getHrefName('filename'))
          // window.location.href = publish.ssoUrl
          Router.push('loginHome')
        }
      })
    })
    return p
  },
  asyncPost (url, data, type) {
    let serviceUrl = publish.baseUrl
    var p = new Promise((resolve, reject) => {
      axios.post(serviceUrl + url, data).then(msg => {
        resolve(msg.data.data)
      }).catch(err => {
        if (err.response.status === 401 || err.response.status === 403) {
          window.localStorage.removeItem('gskToken')
          window.localStorage.removeItem('gskloginInfo')
          // window.location.href = publish.ssoUrl
          Router.push('loginHome')
        }
      })
    })
    return p
  },
  upLoadFile (url, data, cancelToken, upFile) {
    return new Promise((resolve, reject) => {
      // coverGif()
      axios({
        url: publish.baseUrl + url,
        data: data,
        method: 'post',
        onUploadProgress: p => {
          if (p.lengthComputable) { upFile(p) }
        },
        cancelToken: cancelToken
      })
        .then(response => {
          console.log(response)
          // disCover()
          if (response.data) {
            resolve(response.data)
          } else {
            connom.alertTips({
              type: 'error',
              title: '错误:',
              content: response.data.message,
              stayTime: 5
            })
          }
        })
        .catch(err => {
          disCover()
          if (err.response && !returnErr(err)) {
            connom.alertTips({
              type: 'error',
              title: '错误:',
              content: '服务器报错',
              stayTime: 5
            })
          }
          reject(err)
        })
    })
  }
}
function returnErr (err) {
  if (err.response.status === 401 || err.response.status === 403) {
    window.localStorage.removeItem('gskToken')
    window.localStorage.removeItem('gskloginInfo')
    // window.location.href = publish.ssoUrl
    Router.push('loginHome')
    return true
  }
  return false
}
function coverGif () {
  if (!document.getElementById('loadingGif')) {
    let dom = document.createElement('div')
    dom.id = 'loadingGif'
    let html = '<img src="' + avatar + '" height="144" width="192"/>'
    dom.innerHTML = html
    document.getElementById('app').appendChild(dom)
  }
}
function disCover () {
  if (document.getElementById('loadingGif')) {
    document.getElementById('app').removeChild(document.getElementById('loadingGif'))
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/axios.js